import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { spinnerDisplayName, spinnerDefaultProps, spinnerPropTypes } from './Spinner.types';
import { mapColorLabelToHex } from '../../helpers';
var ballClipRotate = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var spinnerWidths = {
  sm: 20,
  md: 48,
  lg: 72
};
var spinnerBorder = {
  sm: 2,
  md: 4,
  lg: 4
};
var CSSSpinner = styled.span.attrs({
  'data-id': function dataId(props) {
    return props['data-id'];
  }
}).withConfig({
  displayName: "Spinner__CSSSpinner",
  componentId: "rfxkfn-0"
})(["position:relative;box-sizing:border-box;width:", "px;height:", "px;display:block;color:", ";&:after{content:'';width:100%;height:100%;display:inline-block;border:", "px solid currentColor;box-sizing:border-box;border-bottom-color:transparent;border-radius:100%;background:transparent;animation:", " 0.75s linear infinite;}"], function (_ref) {
  var size = _ref.size;
  return spinnerWidths[size];
}, function (_ref2) {
  var size = _ref2.size;
  return spinnerWidths[size];
}, function (_ref3) {
  var color = _ref3.color;
  return mapColorLabelToHex(color);
}, function (_ref4) {
  var size = _ref4.size;
  return spinnerBorder[size];
}, ballClipRotate);

var Spinner = function Spinner(_ref5) {
  var color = _ref5.color,
      dataId = _ref5['data-id'],
      show = _ref5.show,
      size = _ref5.size;
  return !show ? null : React.createElement(CSSSpinner, {
    size: size,
    color: color,
    "data-id": dataId
  });
};

Spinner.propTypes = spinnerPropTypes;
Spinner.displayName = spinnerDisplayName;
Spinner.defaultProps = spinnerDefaultProps;
export { Spinner };